import React from 'react'
import 'font-awesome/css/font-awesome.css'
import logoAlmesa from '../assets/images/almesa-logo.png'
import logoBP from '../assets/images/logo-bp.svg'
import mapa from '../assets/images/mapa.svg'
import Collapsible from 'react-collapsible'
import { FormattedMessage, injectIntl } from 'gatsby-plugin-intl'
import slider2_movil from '../assets/images/slider/slider-2-2-movil.jpg'
import styled from 'styled-components'
import media from '../styles/media'
import pdfPoliticaDePrivacidad from '../assets/file/politica-de-privacidad-y-proteccion-datos-almesa-rev-legal.pdf'

const ContainerFooter = styled.div`
    background-color: #fac700;
    padding-top: 10px;

    text-align: left;
    width: 100%;
    font-size: 11px;
    margin-top: 0;
    position: relative;
    bottom: 0;
    img{
      padding: 10px 0;
      margin: auto;
    }
    a{
      color: #fff;
    }
    a:hover{
      color: #fff;
    }
    .centerLogo{
      margin-left: auto !important;
      margin-right: auto !important;
    }
    .textFooterCenter{
      color: #6f6f6e;
      font-family: 'Prelo-Book';
      font-size: 14px;
      margin-left: 25px;
      margin-top: 45px;
      ${media.sm`
        text-align: center;
    `};
    }
    .title {
      color: #0000e2;
      font-size: 16px;
      font-family: 'Prelo Slab';
      padding: 10px 0px;
    }
    .textoFooter {
      color: #6f6f6e;
      font-family: 'Prelo-Book';
      font-size: 14px;
    }

    .Collapsible {
      background-color: #fac700;
      width: 100%;
      border-radius: 5px;
    }
    .Collapsible__contentInner {
      padding: 10px;
      border: none;
      border-top: 0;
    }
    .Collapsible__contentInner p {
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 20px;
    }
    .Collapsible__contentInner p:last-child {
      margin-bottom: 0;
    }
    .Collapsible__trigger {
      display: block;
      font-weight: 400;
      text-decoration: none;
      border-radius: 5px;
      position: relative;
      border: none;
      padding: 10px;
      background: #fac700;
      color: #0000e2;
      font-size: 20px;
      font-family: 'Prelo Slab';
    }

    .Collapsible__trigger:after {
      font-family: 'FontAwesome';
      content: '';
      position: absolute;
      right: 10px;
      top: 10px;
      display: block;
      transition: transform 300ms;
    }
    .Collapsible__trigger.is-open:after {
      transform: rotateZ(180deg);
    }
    .Collapsible__trigger.is-disabled {
      opacity: 0.5;
      background-color: gray;
    }
    .CustomTriggerCSS {
      background-color: #f08080;
      transition: background-color 200ms ease;
    }
    .CustomTriggerCSS--open {
      background-color: #483d8b;
    }
    .Collapsible__custom-sibling {
      padding: 5px;
      font-size: 12px;
      background-color: #cbb700;
      color: #000;
    } /*# sourceMappingURL=collapsible.min.css.map */
    
`

const ContainerSocial = styled.div`
  background-color: #3d3d3d;
  color: #fff;
  padding: 0px 100px;
  ${media.sm`
    padding: 0px;
  `};
  .Copyright {
    padding-left: 0;
    margin-left: -5px;
    margin-bottom: 0;
    margin-top: 9px;
    list-style: none;
    li {
      display: inline-block;
      padding-right: 5px;
      padding-left: 5px;
    }
    ${media.sm`
    text-align: center;
    font-size: 14px;
   `};
  }
  .SocialMediaItem {
    display: inline-block;
    padding-right: 5px;
    padding-left: 5px;
  }
  .SocialMediaItem a {
    color: #ffffff;
  }
  .SocialMediaList  {
    padding-left: 0;
    margin: 9px 0 9px -5px;
    list-style: none;
    text-align: right;
    li {
      display: inline-block;
      padding-right: 5px;
      padding-left: 5px;
    }
    ${media.sm`
     text-align: center;
    `};
   
  }

  .iconSize{
    font-size: 23px;
  }
  
`
const Footer = ({ intl }) => {
  const year = new Date().getFullYear()
  return (
    <ContainerFooter>
      <div className="row">
        <div className="col-md-1 col-xs-12"></div>
        <div className="col-md-2 col-xs-12">
          <img src={logoAlmesa} alt="" className="img-responsive centerLogo" />
          <p className="textFooterCenter">
            <FormattedMessage id="FooterTitle" />
          </p>
          <img src={logoBP} alt="" className="img-responsive centerLogo" />
        </div>
        <div className="col-md-3 col-xs-12  hidden-sm hidden-xs carousel">
          <p className="title">
            <FormattedMessage id="FooterSubtitle" />
          </p>
          <p className="textoFooter">
            <i className="demo-icon icon-iconos-almesa-15">&#xe80e;</i>
            <span>
              <FormattedMessage id="FooterDireccion" />
            </span>
          </p>
          <p className="title">
            <FormattedMessage id="FooterTelefono" />
          </p>
          <p className="textoFooter">
            <i className="demo-icon icon-iconos-almesa-16">&#xe80f;</i>
            <span>
              <FormattedMessage id="FooterDesTelefono" />
            </span>
          </p>
        </div>
        <div className="col-md-4 col-xs-12  hidden-sm hidden-xs carousel">
          <p className="title">
            <FormattedMessage id="FooterEnlacesExternos" />
          </p>
          <p className="textoFooter">
            <i className="demo-icon icon-iconos-almesa-18">&#xe811;</i>
            <a href="https://www.pichincha.com/portal/Inicio">
              <FormattedMessage id="FooterBancoPichincha" />
            </a>
          </p>
          <p className="textoFooter">
            <i className="demo-icon icon-iconos-almesa-18">&#xe811;</i>
            <a href="https://www.consejosfinancieros.org.ec/">
              <FormattedMessage id="FooterPrograma" />
            </a>
          </p>
          <p className="textoFooter">
            <i className="demo-icon icon-iconos-almesa-18">&#xe811;</i>
            <a href={pdfPoliticaDePrivacidad}>Politicas De Privacidad</a>
          </p>
        </div>
        <div className="col-md-2 col-xs-12  hidden-sm hidden-xs">
          <p className="title">
            <FormattedMessage id="FooterMapa" />
          </p>
          <img src={mapa} alt="" className="img-responsive" />
        </div>
        {/* INICIO COLLAPSABLE MOBIL */}
        <div className="hidden-md hidden-lg">
          <Collapsible trigger={intl.formatMessage({ id: 'FooterSubtitle' })}>
            <p className="textoFooter">
              <i className="demo-icon icon-iconos-almesa-15">&#xe80e;</i>
              <span>
                <FormattedMessage id="FooterDireccion" />
              </span>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: 'FooterTelefono' })}>
            <p className="textoFooter">
              <i className="demo-icon icon-iconos-almesa-16">&#xe80f;</i>
              <span>
                <FormattedMessage id="FooterDesTelefono" />
              </span>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: 'FooterEnlacesExternos' })}>
            <p className="textoFooter">
              <i className="demo-icon icon-iconos-almesa-18">&#xe811;</i>
              <a href="https://www.pichincha.com/portal/Inicio">
                <FormattedMessage id="FooterBancoPichincha" />
              </a>
            </p>
            <p className="textoFooter">
              <i className="demo-icon icon-iconos-almesa-18">&#xe811;</i>
              <a href="https://www.consejosfinancieros.org.ec/">
                <FormattedMessage id="FooterPrograma" />
              </a>
            </p>
            <p className="textoFooter">
              <i className="demo-icon icon-iconos-almesa-18">&#xe811;</i>
              <a href={pdfPoliticaDePrivacidad}>Politicas De Privacidad</a>
           </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: 'FooterMapa' })}>
            <img src={mapa} alt="" className="img-responsive" />
          </Collapsible>
        </div>
        {/* FIN COLLAPSABLE MOBIL */}
      </div>

      {/* INICIO  REDES SOCIALES */}
      <ContainerSocial className="row">
        <div className="col-md-6 col-xs-12">
          <div className="Copyright">&copy; Copyright {year} Almesa S.A.</div>
        </div>
        <div className="col-md-6 col-xs-12">
          <div className="SocialMediaList">
            <div className="SocialMediaItem">
              <a href="https://www.facebook.com/almaceneradelecuadorsa/" target="_blank">
                <i className="demo-icon icon-iconos-almesa-19 iconSize">&#xe812;</i>
              </a>
            </div>
            <div className="SocialMediaItem">
              <a href="https://www.instagram.com/almaceneradelecuadors.a/?hl=es-la" target="_blank">
                <i className="demo-icon icon-iconos-almesa-20 iconSize">&#xe813;</i>
              </a>
            </div>
            <div className="SocialMediaItem">
              <a href="https://www.linkedin.com" target="_blank">
                <i className="demo-icon icon-iconos-almesa-21 iconSize">&#xe814;</i>
              </a>
            </div>
          </div>
        </div>
      </ContainerSocial>
      {/* FIN  REDES SOCIALES */}

    </ContainerFooter>
  )
}

export default injectIntl(Footer)
